import { useContext, useEffect, useState } from "react";
import {
  Modal,
  Descriptions,
  Tag,
  Image,
  Button,
  Input,
  DatePicker,
  Space,
} from "antd";
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import dayjs from "dayjs";
import axios from "axios";
import { AuthContext } from "../../context/AuthContext";

export default function ProbationReviewModal({ visible, employee, onClose }) {
  const [remarks, setRemarks] = useState("");
  const { authData, backUrl } = useContext(AuthContext);
  const [extendModalVisible, setExtendModalVisible] = useState(false);
  const [newProbationDate, setNewProbationDate] = useState(null);
  const [approver, setApprover] = useState(null);
  const [allSteps, setAllSteps] = useState([]);
  const [confirmLoading, setConfirmLoading] = useState(false);
  const [extendLoading, setExtendLoading] = useState(false);
  const [separateLoading, setSeparateLoading] = useState(false);
  const [submitExtendLoading, setSubmitExtendLoading] = useState(false);

  const [previousStep, setPreviousStep] = useState(null)

  const [canEdit, setCanEdit] = useState(false);


  useEffect(() => {
    console.log("Details : ", employee.approval_steps);

    setAllSteps(employee.approval_steps);

    const data = employee.approval_steps.filter(
      (item) => item.approver === authData?.employee?.id
    );
    setApprover(data);

    console.log("Approver : ", data)

    const currentIndex = employee.approval_steps.findIndex(
      (item) => item.approver === authData?.employee?.id
    );
    const prevStep = currentIndex > 0 ? employee.approval_steps[currentIndex - 1] : null;
    setPreviousStep(prevStep);
    console.log("Previous Step: ", prevStep);
  }, [employee, authData]);


  useEffect(() => {
    if (previousStep) {
      if (previousStep.status === "Confirm") {
        setCanEdit(true)
      } else {
        setCanEdit(false)
      }
    } else {
      // If there's no previous step (first approver), allow editing
      setCanEdit(true);
    }
  }, [previousStep]);


  useEffect(() => {
    if (approver?.[0]?.remarks) {
      setRemarks(approver[0].remarks);
    }
  }, [approver]);

  if (!employee) return null;
  const emp = employee.employee;

  // Handle decision actions (Confirm, Extend, Separate)
  const handleDecision = async (actionType) => {
    if (!approver) {
      toast.error("Approver information not found.");
      return;
    }

    if (actionType === "Extend") {
      setExtendModalVisible(true);
      return;
    }

    try {
      if (actionType === "Confirm") {
        setConfirmLoading(true);
      } else if (actionType === "Separated") {
        setSeparateLoading(true);
      }

      const payload = {
        action: actionType,
        remarks: remarks || "No remarks provided",
      };

      await axios.post(
        `${backUrl}/api/probation/probation-approvals/${approver[0].id}/submit-decision/`,
        payload,
        {
          headers: { Authorization: `Bearer ${authData?.access}` },
        }
      );

      alert("Decision Made Successfully!")

      toast.success(`Probation ${actionType.toLowerCase()} successfully.`);
      onClose();
    } catch (error) {
      console.error(error);

      const errorMsg =
        error?.response?.data?.detail ||
        error?.response?.data?.message ||
        "Something went wrong while submitting the decision.";

      toast.error(errorMsg);
    } finally {
      setConfirmLoading(false);
      setSeparateLoading(false);
    }
  };

  // Handle "Extend" modal submit
  const handleExtendSubmit = async () => {
    if (!newProbationDate) {
      toast.warning("Please select a new probation end date.");
      return;
    }
    if (!approver) {
      toast.error("Approver information not found.");
      return;
    }

    try {
      setSubmitExtendLoading(true);

      const payload = {
        action: "Extend",
        remarks: remarks || "No remarks provided",
        new_probation_end_date: dayjs(newProbationDate).format("YYYY-MM-DD"),
      };

      await axios.post(
        `${backUrl}/api/probation/probation-approvals/${approver[0].id}/submit-decision/`,
        payload,
        {
          headers: { Authorization: `Bearer ${authData?.access}` },
        }
      );

      toast.success(
        `Probation extended till ${dayjs(newProbationDate).format("DD/MM/YYYY")}`
      );
      setExtendModalVisible(false);
      onClose();
    } catch (error) {
      console.error(error);
      toast.error("Failed to extend probation period.");
    } finally {
      setSubmitExtendLoading(false);
    }
  };



  return (
    <>
      <ToastContainer position="top-right" autoClose={2500} hideProgressBar />

      <Modal
        open={visible}
        title={`Employee Details - ${emp.emp_code} (${approver?.[0]?.status || "Pending"})`}
        onCancel={onClose}
        footer={null}
        width={750}
      >



        {/* Employee details */}
        <Descriptions bordered column={2} size="small">
          <Descriptions.Item label="Name">
            {emp?.first_name} {emp?.last_name}
          </Descriptions.Item>
          <Descriptions.Item label="Organisation & Department">
            {emp.organisation_name} - {emp.department_name}
          </Descriptions.Item>

          <Descriptions.Item label="Designation">
            {emp.designation_name}
          </Descriptions.Item>
          <Descriptions.Item label="Date of Joining">
            {new Date(emp.date_of_joining).toLocaleDateString("en-GB")}
          </Descriptions.Item>

          <Descriptions.Item label="Probation End Date">
            {new Date(employee.final_probation_end_date).toLocaleDateString("en-GB")}
          </Descriptions.Item>
          <Descriptions.Item label="Due Days">
            <Tag
              color={
                "gold"
              }
            >
              {employee.due_days}
            </Tag>
          </Descriptions.Item>

          <Descriptions.Item label="Overall Status">
            <Tag
              color={
                employee.overall_status === "Completed"
                  ? "blue"
                  : employee.overall_status === "Pending"
                    ? "orange"
                    : "default"
              }
            >
              {employee.overall_status}
            </Tag>
          </Descriptions.Item>

          <Descriptions.Item label="Email ID">{emp.email_id}</Descriptions.Item>
          <Descriptions.Item label="Mobile">{emp.mobile_number}</Descriptions.Item>

          <Descriptions.Item label="Location">{emp.location}</Descriptions.Item>
          <Descriptions.Item label="Reporting To">
            {emp.reporting_to_name}
          </Descriptions.Item>

          <Descriptions.Item label="Photo" span={2}>
            <Image
              src={emp.photo}
              alt="Employee Photo"
              width={120}
              height={120}
              style={{ borderRadius: "10px", objectFit: "cover" }}
            />
          </Descriptions.Item>
        </Descriptions>

        {/* Remarks and buttons - Only show if user has permission */}
        {approver?.length > 0 && canEdit && (
          <div style={{ marginTop: 20 }}>
            <label>
              <b>Remarks:</b>
            </label>
            <Input.TextArea
              rows={3}
              placeholder="Enter your remarks here..."
              value={remarks}
              onChange={(e) => setRemarks(e.target.value)}
              style={{ marginTop: 5 }}
            />

            <div style={{ marginTop: 15, textAlign: "center" }}>
              <Space>
                <Button
                  loading={confirmLoading}
                  onClick={() => handleDecision("Confirm")}
                  style={{
                    backgroundColor: "green",
                    color: "white",
                    fontWeight: "500",
                  }}
                >
                  Confirmed
                </Button>

                <Button
                  loading={extendLoading}
                  onClick={() => handleDecision("Extend")}
                  style={{
                    backgroundColor: "#faad14",
                    color: "white",
                    fontWeight: "500",
                  }}
                >
                  Extended
                </Button>

                <Button
                  danger
                  loading={separateLoading}
                  onClick={() => handleDecision("Separated")}
                  style={{ fontWeight: "500" }}
                >
                  Separated
                </Button>
              </Space>
            </div>
          </div>
        )}

        <div style={{ marginTop: 20 }}>
          {allSteps.map((step) => (
            <div
              key={step.id}
              style={{
                border: "none",
                padding: 10,
                marginBottom: 8,
                borderRadius: 6,
                background: step.status === "Confirm"
                  ? "#ffffffff"
                  : step.status === "Pending"
                    ? "#ffffffff"
                    : step.status === "Separate"
                      ? "#ffffffff"
                      : "#ffffffff",
              }}
            >
              <b>
                Step {step.order}: {step.approver_name}
              </b>
              <br />
              Status:{" "}
              <Tag
                color={
                  step.status === "Confirm"
                    ? "green"
                    : step.status === "Pending"
                      ? "orange"
                      : step.status === "Separate"
                        ? "red"
                        : "default"
                }
              >
                {step.status}
              </Tag>
              <br />
              Remarks: {step.remarks || "No remarks"} <br />
              Completed On:{" "}
              {step.completed_on
                ? new Date(step.completed_on).toLocaleString("en-GB")
                : "—"}
              <hr />
            </div>
          ))}
        </div>

      </Modal>

      {/* Nested Modal for Probation Extension */}
      <Modal
        open={extendModalVisible}
        title="Extend Probation Period"
        onCancel={() => setExtendModalVisible(false)}
        onOk={handleExtendSubmit}
        okText="Submit"
        confirmLoading={submitExtendLoading}
      >
        <p>Select probation extension duration:</p>
        <Space style={{ width: "100%", justifyContent: "center", marginTop: 10 }}>
          <Button
            type={
              newProbationDate ===
                dayjs()
                  .add(30, "day")
                  .format("YYYY-MM-DD")
                ? "primary"
                : "default"
            }
            onClick={() =>
              setNewProbationDate(
                dayjs()
                  .add(30, "day")
                  .format("YYYY-MM-DD")
              )
            }
          >
            Extend by 30 Days
          </Button>


          <Button
            type={
              newProbationDate ===
                dayjs()
                  .add(60, "day")
                  .format("YYYY-MM-DD")
                ? "primary"
                : "default"
            }
            onClick={() =>
              setNewProbationDate(
                dayjs()
                  .add(60, "day")
                  .format("YYYY-MM-DD")
              )
            }
          >
            Extend by 60 Days
          </Button>
        </Space>

        {newProbationDate && (
          <p style={{ marginTop: 15, textAlign: "center" }}>
            New Probation End Date:{" "}
            <b>{dayjs(newProbationDate).format("DD/MM/YYYY")}</b>
          </p>
        )}
      </Modal>

    </>
  );
}